export default {
    // Endpoints
    loginEndpoint: "/api/auth/login",
    registerEndpoint: "/api/auth/register",
    refreshEndpoint: "/api/auth/refresh",
    logoutEndpoint: "/api/auth/logout",

    tokenType: "Bearer",

    // Value of this property will be used as key to store JWT token in storage
    storageTokenKeyName: "accessToken",
    storageRefreshTokenKeyName: "refreshToken"
};
